import { COOKIES_KEYS } from '@/constants';

export const ONBOARDING_COOKIES_KEYS = {
	VERSION_NAME: COOKIES_KEYS.VERSION_NAME,
	PAGE_NUMBER: 'onboarding_page_number',
	TEST_VARIANT: COOKIES_KEYS.TEST_VARIANT,
	TEST_NAME: COOKIES_KEYS.TEST_NAME,
	TESTS: 'onboarding_tests',
	USER_TOKEN: 'auth_token',
} as const;
